module.exports = __webpack_public_path__ + "static/media/checkbox_checked.3cd087e6.svg";